module.exports = __webpack_public_path__ + "static/media/img25.926939b8.jpg";